import ApiService from "../service/apiService";
import { useDispatch, useSelector } from "react-redux";
import {
  setCountryList,
  setStateList,
  setDistrictList,
  setMunicipalityList,
  setBankList,
  setBankAccountTypeList,
  setBusinessTypeList,
  setCompanyTypeList,
  setDesignationList,
  setRelationTypeList,
  setFinancialDetailsList,
  setOccupationTypeList,
  setDocumentTypeList,
  setDpList,
  setDirectorTypeList,
  setBankBranchList,
} from "../../redux/lookupSlice";

class LookupService {
  getCountryList(dispatch) {
    ApiService.getCountryList().then((response) => {
      dispatch(setCountryList(response.data.data));
    });
  }

  getStateList(dispatch) {
    ApiService.getStateList().then((response) => {
      dispatch(setStateList(response.data.data));
    });
  }
  getDistrictList(dispatch) {
    ApiService.getDistrictList().then((response) => {
      dispatch(setDistrictList(response.data.data));
    });
  }

  getMunicipalityList(dispatch) {
    ApiService.getMunicipalityList().then((response) => {
      dispatch(setMunicipalityList(response.data.data));
    });
  }

  getBankList(dispatch) {
    ApiService.getBankList().then((response) => {
      dispatch(setBankList(response.data.data));
    });
  }

  getBankAccountTypeList(dispatch) {
    ApiService.getBankAccountTypeList().then((response) => {
      dispatch(setBankAccountTypeList(response.data.data));
    });
  }

  getCompanyTypeList(dispatch) {
    ApiService.getCompanyTypeList().then((response) => {
      dispatch(setCompanyTypeList(response.data.data));
    });
  }

  getDesignationList(dispatch) {
    ApiService.getDesignationList().then((response) => {
      dispatch(setDesignationList(response.data.data));
    });
  }

  getFinancialDetailsList(dispatch) {
    ApiService.getFinancialDetailsList().then((response) => {
      dispatch(setFinancialDetailsList(response.data.data));
    });
  }
  getRelationTypeList(dispatch) {
    ApiService.getRelationTypeList().then((response) => {
      dispatch(setRelationTypeList(response.data.data));
    });
  }

  getBusinessTypeList(dispatch) {
    ApiService.getBusinessTypeList().then((response) => {
      dispatch(setBusinessTypeList(response.data.data));
    });
  }

  getOccupationTypeList(dispatch) {
    ApiService.getOccupationTypeList().then((response) => {
      dispatch(setOccupationTypeList(response.data.data));
    });
  }

  getDocumentTypeList(dispatch) {
    ApiService.getDocumentTypeList().then((response) => {
      dispatch(setDocumentTypeList(response.data.data));
    });
  }

  getDpList(dispatch) {
    ApiService.getDpList().then((response) => {
      dispatch(setDpList(response.data.data));
    });
  }
  getDirectorTypeList(dispatch) {
    ApiService.getDirectorTypeList().then((response) => {
      dispatch(setDirectorTypeList(response.data.data));
    });
  }
  getAllBankBranchList(bankCode, dispatch) {
    return ApiService.getAllBankBranchList(bankCode);
  }
  getBankBranch(dispatch) {
    ApiService.getBankBranch().then((response) => {
      dispatch(setBankBranchList(response.data.data));
    });
  }
}
export default new LookupService();
